export default class StringUtils {

	static getInitials(name: string): string {
	    if (!name) return '';
	    return name
	        .split(' ') // Split the name into parts by spaces
	        .filter(Boolean) // Remove any empty strings (in case of extra spaces)
	        .map((part) => part[0].toUpperCase()) // Take the first character of each part and capitalize it
	        .join(''); // Join the initials together
	}


	static formatCurrency(value: number, currency:string, locale:string): string {
		const formatter = new Intl.NumberFormat(locale, {
			maximumFractionDigits: 0,
			useGrouping: true,
		});

		const formattedValue: string = formatter.format(value);

		if (currency == 'BGN') {
			return formattedValue + ' лв';
		}
		return formattedValue + ' ' + currency;
	}

	static formatPhoneNumber(phoneNumber: string): string {
		return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3');
	}
}